import { icons } from './../../assets/iconDef/icon.def'
export const inventoryMenuDef = [
    {
        name: 'menu.inventory_worklist',
        icon: 'fa fa-building-o',
        children: [
            {
                name: 'Rate Contract',
                resource: 'rate_contract_comparision',
                icon: 'fa fa-user',
                url: 'rate_contract_comparision',
                auto_crud: true,
                breadcrumb: 'Rate Contract comparison',
            },
            {
                name: 'menu.direct_receive',
                resource: 'grnLayout',
                icon: 'fa fa-user',
                url: 'grnLayout',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },
            {
                name: 'menu.direct_receive',
                resource: 'consignmentGrnMaster',
                icon: 'fa fa-user',
                url: 'consignmentGrnMaster',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },
            {
                name: 'menu.direct_receive',
                resource: 'directRecieveMaster',
                icon: 'fa fa-user',
                url: 'directRecieveMaster',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },
            {
                name: 'menu.direct_receive',
                resource: 'directRecieveMasterReturn',
                icon: 'fa fa-user',
                url: 'directRecieveMasterReturn',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },
            {
                name: 'menu.direct_receive',
                resource: 'directRecieveGrn_return_itemWise',
                icon: 'fa fa-user',
                url: 'directRecieveGrn_return_itemWise',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },

            {
                name: 'menu.direct_receive_return',
                resource: 'grn_Return_layout',
                icon: 'fa fa-user',
                url: 'grn_return_layout',
                auto_crud: true,
                breadcrumb: 'Direct Receive Return'
            },
            {
                name: 'menu.stock_ledger',
                resource: 'ledgerBidCard',
                icon: 'fa fa-user',
                url: 'ledgerBidCard',
                auto_crud: true,
                breadcrumb: 'Stock Ledger'
            },
            {
                name: 'menu.consignmentStockLedger',
                resource: 'consignmentStockLedger',
                icon: 'fa fa-user',
                url: 'consignmentStockLedger',
                auto_crud: true,
                breadcrumb: 'Consignment Stock Ledger'
            },
            {
                name: 'menu.stock_ledger',
                resource: 'stockLedger',
                icon: 'fa fa-user',
                url: 'stockLedger',
                auto_crud: true,
                breadcrumb: 'Stock Ledger'
            },
            {
                name: 'menu.reusable_stock_ledger',
                resource: 'reusableStockLedger',
                icon: 'fa fa-user',
                url: 'reusableStockLedger',
                auto_crud: true,
                breadcrumb: 'Reusable Stock Ledger'
            },
            {
                name: 'menu.stock_ledger',
                resource: 'stockLedgerLayout',
                icon: 'fa fa-user',
                url: 'stockLedgerLayout',
                auto_crud: true,
                breadcrumb: 'Stock Ledger'
            },
            {
                name: 'menu.view_stock',
                resource: 'stock',
                icon: 'fa fa-user',
                url: 'stock',
                auto_crud: true,
                breadcrumb: 'View Stock'
            },
            {
                name: 'menu.physicalStock',
                resource: 'physicalStock',
                icon: 'fa fa-user',
                url: 'physicalStock',
                auto_crud: true,
                breadcrumb: 'Physical Stock'
            },
            {
                name: 'menu.received_raised_indent',
                resource: 'central_received_indent_raised',
                icon: 'fa fa-user',
                url: 'central_received_indent_raised',
                auto_crud: true,
                breadcrumb: 'Central Received Indent Raised'
            },

            {
                name: 'menu.issue_indent',
                resource: 'central_indent_issued',
                icon: 'fa fa-user',
                url: 'central_indent_issued',
                auto_crud: true,
                breadcrumb: 'Central Indent Issued'
            },

            {
                name: 'menu.raised_indent',
                resource: 'central_indent_raised',
                icon: 'fa fa-user',
                url: 'central_indent_raised',
                auto_crud: true,
                breadcrumb: 'Central Indent Raised'
            },
            {
                name: 'menu.received_return_indent',
                resource: 'central_received_return_indent',
                icon: 'fa fa-user',
                url: 'central_received_return_indent',
                auto_crud: true,
                breadcrumb: 'Central Recieved Return Indent'
            },
            {
                name: 'menu.central_return_indent',
                resource: 'central_return_indent',
                icon: 'fa fa-user',
                url: 'central_return_indent',
                auto_crud: true,
                breadcrumb: 'Central Return Indent'
            }
            , {
                name: 'menu.central_received_indent_issued',
                resource: 'central_received_indent_issued',
                icon: 'fa fa-user',
                url: 'central_received_indent_issued',
                auto_crud: true,
                breadcrumb: 'Central Received Indent Issued'
            },
            {
                name: 'menu.direct_receive',
                resource: 'grnMaster',
                icon: 'fa fa-user',
                url: 'grnMaster',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },
            {
                name: 'menu.store_consumption',
                resource: 'storeConsumptionLayout',
                icon: 'fa fa-user',
                url: 'storeConsumptionLayout',
                auto_crud: true,
                breadcrumb: 'Store Consumption'
            },
            {
                name: 'menu.store_consumption',
                resource: 'storeConsumption',
                icon: 'fa fa-user',
                url: 'storeConsumption',
                auto_crud: true,
                breadcrumb: 'Store Consumption'
            },
            {
                name: 'menu.view_stock',
                resource: 'stockLayout',
                icon: 'fa fa-user',
                url: 'stockLayout',
                auto_crud: true
            },
            {
                name: 'menu.view_stock',
                resource: 'brokenStockParent',
                icon: 'fa fa-user',
                url: 'brokenStockParent',
                auto_crud: true
            },
            {
                name: 'menu.stock_adjustment',
                resource: 'stock_adjustment',
                icon: 'fa fa-user',
                url: 'stock_adjustment',
                auto_crud: true
            },
            {
                name: 'menu.temp_monitoring',
                resource: 'tempMonitoring',
                icon: 'fa fa-user',
                url: 'tempMonitoring',
                auto_crud: true
            },
            {
                name: 'menu.inventory_direct_issue',
                resource: 'inventory_direct_issue',
                icon: 'fa fa-user',
                url: 'inventory_direct_issue',
                auto_crud: true,
                breadcrumb: 'Inventory Direct Issue'
            },
            {
                name: 'menu.interfacility_direct_issue',
                resource: 'interfacility_issue_layout',
                icon: 'fa fa-user',
                url: 'interfacility_issue_layout',
                auto_crud: true,
                breadcrumb: 'Interfacility Direct Issue'
            },
            {
                name: 'menu.inventory_direct_issue_receipt',
                resource: 'inventory_direct_issue_receipt',
                icon: 'fa fa-user',
                url: 'inventory_direct_issue_receipt',
                auto_crud: true,
                breadcrumb: 'Inventory Direct Issue Receipt'
            },
            {
                name: 'menu.inventory_direct_issue_reject_receive',
                resource: 'inventory_direct_issue_reject_receive',
                icon: 'fa fa-user',
                url: 'inventory_direct_issue_reject_receive',
                auto_crud: true,
                breadcrumb: 'Inventory Direct Issue Reject Acknowledge'
            },
            {
                name: 'menu.interfacility_direct_issue',
                resource: 'interfacility_direct_issue',
                icon: 'fa fa-user',
                url: 'interfacility_direct_issue',
                auto_crud: true,
                breadcrumb: 'Interfacility Direct Issue'
            },
            {
                name: 'menu.interfacility_direct_issue_receipt',
                resource: 'interfacility_direct_issue_receipt',
                icon: 'fa fa-user',
                url: 'interfacility_direct_issue_receipt',
                auto_crud: true,
                breadcrumb: 'Interfacility Direct Issue Receipt'
            },
            {
                name: 'menu.indent',
                resource: 'indentLayout',
                icon: 'fa fa-user',
                url: 'indentLayout',
                auto_crud: true,
                breadcrumb: 'Indent'
            },
            {
                name: 'menu.consignmentIssueReturnLayout',
                resource: 'consignmentIssueReturnLayout',
                icon: 'fa fa-user',
                url: 'consignmentIssueReturnLayout',
                auto_crud: true,
                breadcrumb: 'Consignment Issue Return Layout'
            },
            {
                name: 'menu.transitLayout',
                resource: 'transitLayout',
                icon: 'fa fa-user',
                url: 'transitLayout',
                auto_crud: true,
                breadcrumb: 'Transit Report'
            },
            {
                name: 'menu.interfacility_transfer_config',
                resource: 'interfacility_transfer_config',
                icon: 'fa fa-user',
                url: 'interfacility_transfer_config',
                auto_crud: true,
                breadcrumb: 'Interfacility Stock transfer config'
            },
            {
                name: 'menu.interfacility_indentLayout',
                resource: 'interfacility_indentLayout',
                icon: 'fa fa-user',
                url: 'interfacility_indentLayout',
                auto_crud: true,
                breadcrumb: 'Interfacility Stock transfer'
            },
            {
                name: 'menu.substitute_lookup',
                resource: 'substitute_lookup',
                icon: 'icons.application.user',
                url: 'substitute_lookup',
                auto_crud: true,
                breadcrumb: 'Ip substitute_lookup',
                check_permission: false
            },
            {
                name: 'menu.interfacility_sale_indentLayout',
                resource: 'interfacility_sale_indentLayout',
                icon: 'fa fa-user',
                url: 'interfacility_sale_indentLayout',
                auto_crud: true,
                breadcrumb: 'Interfacility Stock Sale/Sale'
            },
            {
                name: 'menu.interfacility_sale_indent_raised',
                resource: 'interfacility_sale_indent_raised',
                icon: 'fa fa-user',
                url: 'interfacility_sale_indent_raised',
                auto_crud: true
            },
            {
                name: 'menu.interfacility_sale_issue_indent',
                resource: 'interfacility_sale_issue_indent',
                icon: 'fa fa-user',
                url: 'interfacility_sale_issue_indent',
                auto_crud: true
            },
            {
                name: 'menu.interfacility_sale_receive_indent',
                resource: 'interfacility_sale_receive_indent',
                icon: 'fa fa-user',
                url: 'interfacility_sale_receive_indent',
                auto_crud: true
            },
            {
                name: 'menu.interfacility_sale_indent_issued',
                resource: 'interfacility_sale_indent_issued',
                icon: 'fa fa-user',
                url: 'interfacility_sale_indent_issued',
                auto_crud: true
            },
            {
                name: 'menu.interfacility_indent_raised',
                resource: 'interfacility_indent_raised',
                icon: 'fa fa-user',
                url: 'interfacility_indent_raised',
                auto_crud: true
            },
            {
                name: 'menu.hod_approve_interfacility_indent',
                resource: 'hod_approve_interfacility_indent',
                icon: 'fa fa-user',
                url: 'hod_approve_interfacility_indent',
                auto_crud: true
            },
            {
                name: 'menu.approve_interfacility_indent',
                resource: 'approve_interfacility_indent',
                icon: 'fa fa-user',
                url: 'approve_interfacility_indent',
                auto_crud: true
            },
            {
                name: 'menu.l1_approve_interfacility_indent',
                resource: 'l1_approve_interfacility_indent',
                icon: 'fa fa-user',
                url: 'l1_approve_interfacility_indent',
                auto_crud: true
            },
            {
                name: 'menu.approve_interfacility_sale_indent',
                resource: 'approve_interfacility_sale_indent',
                icon: 'fa fa-user',
                url: 'approve_interfacility_sale_indent',
                auto_crud: true
            },
            {
                name: 'menu.l1_interfacility_sale_indent_raised',
                resource: 'l1_interfacility_sale_indent_raised',
                icon: 'fa fa-user',
                url: 'l1_interfacility_sale_indent_raised',
                auto_crud: true
            },
            {
                name: 'menu.hod_approve_interfacility_sale_indent',
                resource: 'hod_approve_interfacility_sale_indent',
                icon: 'fa fa-user',
                url: 'hod_approve_interfacility_sale_indent',
                auto_crud: true
            },
            {
                name: 'menu.interfacility_issue_indent',
                resource: 'interfacility_issue_indent',
                icon: 'fa fa-user',
                url: 'interfacility_issue_indent',
                auto_crud: true
            },
            {
                name: 'menu.interfacility_receive_indent',
                resource: 'interfacility_receive_indent',
                icon: 'fa fa-user',
                url: 'interfacility_receive_indent',
                auto_crud: true
            },
            {
                name: 'menu.interfacility_indent_issued',
                resource: 'interfacility_indent_issued',
                icon: 'fa fa-user',
                url: 'interfacility_indent_issued',
                auto_crud: true
            },
               {
                name: 'menu.brokenStockApproval',
                resource: 'brokenStockApproval',
                icon: 'fa fa-user',
                url: 'brokenStockApproval',
                auto_crud: true,
                breadcrumb: 'brokenStockApproval'
            },
            {
                name: 'menu.interfacility_indent_return',
                resource: 'interfacility_indent_return',
                icon: 'fa fa-user',
                url: 'interfacility_indent_return',
                auto_crud: true
            },
            {
                name: 'menu.interfacility_return_acknowledge',
                resource: 'interfacility_return_acknowledge',
                icon: 'fa fa-user',
                url: 'interfacility_return_acknowledge',
                auto_crud: true
            }, {
                name: 'menu.interfacility_sale_indent_return',
                resource: 'interfacility_sale_indent_return',
                icon: 'fa fa-user',
                url: 'interfacility_sale_indent_return',
                auto_crud: true
            },
            {
                name: 'menu.interfacility_sale_return_acknowledge',
                resource: 'interfacility_sale_return_acknowledge',
                icon: 'fa fa-user',
                url: 'interfacility_sale_return_acknowledge',
                auto_crud: true
            },
            {
                name: "menu.directGrn_return_itemWise",
                "resource": "directGrn_return_itemWise",
                "url": "directGrn_return_itemWise",
                "auto_crud": true
            },
            {
                name: "menu.direct_consignment_return",
                "resource": "direct_consignment_return",
                "url": "direct_consignment_return",
                "auto_crud": true
            },
            {
                name: 'Service Agreement Rate Contract',
                resource: 'service_agreement_rc_parent',
                icon: 'fa fa-user',
                url: 'service_agreement_rc_parent',
                auto_crud: true,
                breadcrumb: 'Service Agreement Rate Contract',
            },
            {
                name: 'Service Agreement - Rate Contract Approval',
                resource: 'service_agreement_rc_approval',
                icon: 'fa fa-user',
                url: 'service_agreement_rc_approval',
                auto_crud: true,
                breadcrumb: 'Service Agreement - Rate Contract Approval',
            },
            {
                name: 'menu.stockAdjustmentApprovalLayout',
                resource: 'stockAdjustmentApprovalLayout',
                icon: 'fa fa-user',
                url: 'stockAdjustmentApprovalLayout',
                auto_crud: true,
                breadcrumb: 'Stock Adjustment Approval Mapping'
            },
            {
                name: 'menu.stock_adjustment_approval_level',
                resource: 'stock_adjustment_approval_level',
                icon: 'fa fa-user',
                url: 'stock_adjustment_approval_level',
                auto_crud: true,
                breadcrumb: 'stock_adjustment_approval_level'
            },
            {
                name: 'menu.stock_adjustment_approval_mapping',
                resource: 'stock_adjustment_approval_mapping',
                icon: 'fa fa-user',
                url: 'stock_adjustment_approval_mapping',
                auto_crud: true,
                breadcrumb: 'stock_adjustment_approval_mapping'
            }
        ]
    },
    {
        name: 'menu.inventory_master',
        icon: 'fa fa-building-o',
        children: [
            {
                name: 'menu.item',
                resource: 'item',
                icon: 'fa fa-user',
                url: 'item',
                auto_crud: true,
                breadcrumb: 'Item List'
            },
            {
                name: 'menu.supplier',
                resource: 'supplier',
                icon: 'fa fa-user',
                url: 'supplier',
                auto_crud: true,
                breadcrumb: 'Supplier List'
            },
            {
                name: 'menu.supplier_approval',
                resource: 'supplier_approval',
                icon: 'fa fa-user',
                url: 'supplier_approval',
                auto_crud: true,
                breadcrumb: 'Supplier Approval List'
            },
            {
                name: 'menu.manufacturer',
                resource: 'manufacturer',
                icon: 'fa fa-user',
                url: 'manufacturer',
                auto_crud: true,
                breadcrumb: 'Manufacturer List'
            },
            {
                name: 'menu.marketer',
                resource: 'marketer',
                icon: 'fa fa-user',
                url: 'marketer',
                auto_crud: true,
                breadcrumb: 'Marketer List'
            },
            {
                name: 'menu.supplier_item',
                resource: 'supplier_item',
                icon: 'fa fa-user',
                url: 'supplier_item',
                auto_crud: true,
                breadcrumb: 'Supplier-Item'
            },
            {
                name: 'menu.optical_supplier_item',
                resource: 'optical_supplier_item',
                icon: 'fa fa-user',
                url: 'optical_supplier_item',
                auto_crud: true,
                breadcrumb: 'Supplier-Item'
            },
            {
                name: 'menu.store',
                icon: 'fa fa-building-o',
                resource: 'store',
                url: 'store',
                auto_crud: true,
                breadcrumb: 'Store List'
            },
            {
                name: 'menu.drug_license',
                resource: 'drugLicense',
                icon: 'fa fa-user',
                url: 'drugLicense',
                auto_crud: true,
                breadcrumb: 'Drug License List'
            },
            {
                name: 'menu.hsn_master',
                resource: 'hsnMaster',
                icon: 'fa fa-user',
                url: 'hsnMaster',
                auto_crud: true,
                breadcrumb: 'HSN Master'
            },
            {
                name: 'menu.itemCategory',
                resource: 'itemCategory',
                icon: 'fa fa-user',
                url: 'itemCategory',
                auto_crud: true,
                breadcrumb: 'Item Category'
            },
            {
                name: 'menu.itemSubCategory',
                resource: 'itemSubCategory',
                icon: 'fa fa-user',
                url: 'itemSubCategory',
                auto_crud: true,
                breadcrumb: 'Item SubCategory'
            },
            {
                name: 'menu.itemSubCategory',
                resource: 'categorySubCategory',
                icon: 'fa fa-user',
                url: 'categorySubCategory',
                auto_crud: true,
                breadcrumb: 'Item SubCategory'
            },
            {
                name: 'menu.category_subCategory_mapping',
                resource: 'itemTypeCategorySubCategoryMapping',
                icon: 'fa fa-user',
                url: 'itemTypeCategorySubCategoryMapping',
                auto_crud: true,
                breadcrumb: 'Category-SubCategory Mapping'
            },
            {
                name: 'menu.item_kit_mapping',
                resource: 'itemKitMapping',
                icon: 'fa fa-user',
                url: 'itemKitMapping',
                auto_crud: true,
                breadcrumb: 'Item Kit Mapping'
            },
            {
                name: 'menu.drugForm_dosage_mapping',
                resource: 'drugForm_dosage_mapping',
                icon: 'fa fa-user',
                url: 'drugForm_dosage_mapping',
                auto_crud: true,
                breadcrumb: 'Drugform Dosage Mapping'
            },
            {
                name: 'menu.drugForm_dosage_mapping',
                resource: 'storeconsumption_view',
                icon: 'fa fa-user',
                url: 'storeconsumption_view',
                auto_crud: true,
                breadcrumb: 'Drugform Dosage Mapping'
            },
            {
                name: 'menu.itemTypeCategory',
                resource: 'itemTypeCategoryMapping',
                icon: 'fa fa-user',
                url: 'itemTypeCategoryMapping',
                auto_crud: true,
                breadcrumb: 'ItemType-Category Mapping'
            },
            {
                name: 'menu.itemTypeCategory',
                resource: 'itemTypeCategory',
                icon: 'fa fa-user',
                url: 'itemTypeCategory',
                auto_crud: true,
                breadcrumb: 'ItemType-Category Mapping'
            },
            {
                name: 'menu.itemTypeCategory',
                resource: 'itemTypeCategorySubCategoryTab',
                icon: 'fa fa-user',
                url: 'itemTypeCategorySubCategoryTab',
                auto_crud: true,
                breadcrumb: 'ItemType-Category Mapping'
            },
            {
                name: 'menu.categorySubCategory',
                resource: 'itemCategorySubCategoryMapping',
                icon: 'fa fa-user',
                url: 'itemCategorySubCategoryMapping',
                auto_crud: true,
                breadcrumb: 'Category-SubCategory Mapping'
            },
            {
                name: 'menu.itemGenericMapping',
                resource: 'itemGenericMapping',
                icon: 'fa fa-user',
                url: 'itemGenericMapping',
                auto_crud: true,
                breadcrumb: 'Item Generic Mapping'
            },
            {
                name: 'menu.storeItemMapping',
                resource: 'store_item',
                icon: 'fa fa-user',
                url: 'store_item',
                auto_crud: true,
                breadcrumb: 'Store Item Mapping'
            },
            {
                name: 'menu.payer_item',
                resource: 'payer_item',
                icon: 'fa fa-user',
                url: 'payer_item',
                auto_crud: true,
                breadcrumb: 'Payer Item'
            },
            {
                name: 'menu.storeWardMapping',
                resource: 'store_ward_mapping',
                icon: 'fa fa-user',
                url: 'store_ward_mapping',
                auto_crud: true,
                breadcrumb: 'Store Ward Mapping'
            },
            {
                name: 'menu.item_approval',
                resource: 'item_approval',
                icon: 'fa fa-user',
                url: 'item_approval',
                auto_crud: true,
                breadcrumb: 'Item Approval'
            },
            {
                name: 'menu.item_rate_contract',
                resource: 'supplier_item_rc_parent',
                icon: 'fa fa-user',
                url: 'supplier_item_rc_parent',
                auto_crud: true,
                breadcrumb: 'Item Rate Contract'
            },
            {
                name: 'menu.supplier_item_rc_approval',
                resource: 'supplier_item_rc_approval',
                icon: 'fa fa-user',
                url: 'supplier_item_rc_approval',
                auto_crud: true,
                breadcrumb: 'Item Rate Contract Approval'
            },
            {
                name: 'menu.sa_item',
                resource: 'sa_item',
                icon: 'fa fa-user',
                url: 'sa_item',
                auto_crud: true,
                breadcrumb: 'Service Agreement Item List'
            },
            {
                name: 'menu.sa_item_approval',
                resource: 'sa_item_approval',
                icon: 'fa fa-user',
                url: 'sa_item_approval',
                auto_crud: true,
                breadcrumb: 'Service Agreement Item Approval List'
            },
            {
                name: 'menu.sa_store_item',
                resource: 'sa_store_item',
                icon: 'fa fa-user',
                url: 'sa_store_item',
                auto_crud: true,
                breadcrumb: 'Service Agreement - Store Item'
            },
            {
                name: 'menu.sa_supplier_item',
                resource: 'sa_supplier_item',
                icon: 'fa fa-user',
                url: 'sa_supplier_item',
                auto_crud: true,
                breadcrumb: 'Service Agreement - Supplier Item'
            }
        ]
    },
    {
        name: 'menu.scm',
        icon: 'fa fa-building-o',
        children: [
            {
                name: 'menu.purchase_request',
                resource: 'purchase_request',
                icon: 'fa fa-user',
                url: 'purchase_request',
                auto_crud: true,
                breadcrumb: 'Purchase Request'
            },
             {
                name: 'menu.sa_purchase_request',
                resource: 'sa_purchase_request',
                icon: 'fa fa-user',
                url: 'sa_purchase_request',
                auto_crud: true,
                breadcrumb: 'Service Agreement Purchase Request'
            },
            {
                name: 'menu.item_type_approval_level',
                resource: 'item_type_approval_level',
                icon: 'fa fa-user',
                url: 'item_type_approval_level',
                auto_crud: true,
                breadcrumb: 'Item Type Approval Level'
            },
            {
                name: 'menu.pr_approval_mapping',
                resource: 'prApprovalCardLayout',
                icon: 'fa fa-user',
                url: 'prApprovalCardLayout',
                auto_crud: true,
                breadcrumb: 'PR Item Type Level Mapping'
            },
            {
                name: 'menu.pr_item_type_level',
                resource: 'pr_item_type_level',
                icon: 'fa fa-user',
                url: 'pr_item_type_level',
                auto_crud: true,
                breadcrumb: 'pr_item_type_level'
            },
            {
                name: 'menu.pr_item_type_approval_mapping',
                resource: 'pr_item_type_approval_mapping',
                icon: 'fa fa-user',
                url: 'pr_item_type_approval_mapping',
                auto_crud: true,
                breadcrumb: 'pr_item_type_approval_mapping'
            },
            {
                name: 'menu.po_approval_mapping',
                resource: 'poApprovalCardLayout',
                icon: 'fa fa-user',
                url: 'poApprovalCardLayout',
                auto_crud: true,
                breadcrumb: 'PO Item Type Level Mapping'
            },
            {
                name: 'menu.sa_rc_layout',
                resource: 'sa_rc_layout',
                icon: 'fa fa-user',
                url: 'sa_rc_layout',
                auto_crud: true,
                breadcrumb: 'SA-RC Item Type Level Mapping'
            },
            {
                name: 'menu.sa_rc_item_type_level',
                resource: 'sa_rc_item_type_level',
                icon: 'fa fa-user',
                url: 'sa_rc_item_type_level',
                auto_crud: true,
                breadcrumb: 'sa_rc_item_type_level'
            },
            {
                name: 'menu.sa_rc_item_type_approval_mapping',
                resource: 'sa_rc_item_type_approval_mapping',
                icon: 'fa fa-user',
                url: 'sa_rc_item_type_approval_mapping',
                auto_crud: true,
                breadcrumb: 'sa_rc_item_type_approval_mapping'
            },
            {
                name: 'menu.po_item_type_level',
                resource: 'po_item_type_level',
                icon: 'fa fa-user',
                url: 'po_item_type_level',
                auto_crud: true,
                breadcrumb: 'po_item_type_level'
            },
            {
                name: 'menu.po_item_type_approval_mapping',
                resource: 'po_item_type_approval_mapping',
                icon: 'fa fa-user',
                url: 'po_item_type_approval_mapping',
                auto_crud: true,
                breadcrumb: 'po_item_type_approval_mapping'
            },
            {
                name: 'menu.scmGatePassMenu',
                resource: 'scmGatePassMenu',
                icon: 'fa fa-user',
                url: 'scmGatePassMenu',
                auto_crud: true,
                breadcrumb: 'scmGatePassMenu'
            },
            {
                name: 'menu.scm_gate_pass_in',
                resource: 'scm_gate_pass_in',
                icon: 'fa fa-user',
                url: 'scm_gate_pass_in',
                auto_crud: true,
                breadcrumb: 'scm_gate_pass_in'
            },
            {
                name: 'menu.scm_gate_pass_in_draft',
                resource: 'scm_gate_pass_in_draft',
                icon: 'fa fa-user',
                url: 'scm_gate_pass_in_draft',
                auto_crud: true,
                breadcrumb: 'scm_gate_pass_in_draft'
            },
            {
                name: 'menu.scm_gate_pass_out',
                resource: 'scm_gate_pass_out',
                icon: 'fa fa-user',
                url: 'scm_gate_pass_out',
                auto_crud: true,
                breadcrumb: 'scm_gate_pass_out'
            },
            {
                name: 'menu.scm_gate_pass_out_draft',
                resource: 'scm_gate_pass_out_draft',
                icon: 'fa fa-user',
                url: 'scm_gate_pass_out_draft',
                auto_crud: true,
                breadcrumb: 'scm_gate_pass_out_draft'
            },
            {
                name: 'menu.sa_purchase_request_approval',
                resource: 'sa_purchase_request_approval',
                icon: 'fa fa-user',
                url: 'sa_purchase_request_approval',
                auto_crud: true,
                breadcrumb: 'Service Agreement Purchase Request Approval'
            },
            {
                name: 'menu.purchase_request_approval',
                resource: 'purchase_request_approval',
                icon: 'fa fa-user',
                url: 'purchase_request_approval',
                auto_crud: true,
                breadcrumb: 'Purchase Request Approval'
            },
            {
                name: 'menu.po_level',
                resource: 'po_level',
                icon: 'fa fa-user',
                url: 'po_level',
                auto_crud: true,
                breadcrumb: 'PO Approval Level'
            },
            {
                name: 'menu.po_level_mapping',
                resource: 'po_level_mapping',
                icon: 'fa fa-user',
                url: 'po_level_mapping',
                auto_crud: true,
                breadcrumb: 'PO Approval Level Mapping'
            },
            {
                name: 'menu.sa_rc_level_mapping',
                resource: 'sa_rc_level_mapping',
                icon: 'fa fa-user',
                url: 'sa_rc_level_mapping',
                auto_crud: true,
                breadcrumb: 'Service Agreement RC Level Mapping'
            },
            {
                name: 'menu.po_term_condition',
                resource: 'po_term_condition',
                icon: 'fa fa-user',
                url: 'po_term_condition',
                auto_crud: true,
                breadcrumb: 'PO Term & Condition'
            },
            {
                name: 'menu.purchase_order',
                resource: 'purchase_order',
                icon: 'fa fa-user',
                url: 'purchase_order',
                auto_crud: true,
                breadcrumb: 'Purchase Order'
            },
            {
                name: 'menu.purchase_order_approval',
                resource: 'purchase_order_approval',
                icon: 'fa fa-user',
                url: 'purchase_order_approval',
                auto_crud: true,
                breadcrumb: 'Purchase Order Approval'
            },
            {
                name: 'menu.sa_purchase_order',
                resource: 'sa_purchase_order',
                icon: 'fa fa-user',
                url: 'sa_purchase_order',
                auto_crud: true,
                breadcrumb: 'Service Agreement Purchase Order'
            },
            {
                name: 'menu.sa_purchase_order_approval',
                resource: 'sa_purchase_order_approval',
                icon: 'fa fa-user',
                url: 'sa_purchase_order_approval',
                auto_crud: true,
                breadcrumb: 'Service Agreement Purchase Order Approval'
            },
            {
                name: 'menu.consignmentLayout',
                resource: 'consignmentLayout',
                icon: 'fa fa-user',
                url: 'consignmentLayout',
                auto_crud: true
            },
            {
                name: 'menu.consignment_challan',
                resource: 'consignment_challan',
                icon: 'fa fa-user',
                url: 'consignment_challan',
                auto_crud: true,
                breadcrumb: 'Consignment Challan'
            },
            {
                name: 'menu.consignment_issue',
                resource: 'consignment_issue',
                icon: 'fa fa-user',
                url: 'consignment_issue',
                auto_crud: true,
                breadcrumb: 'Consignment Issue'
            },
            {
                name: 'menu.consignment_issue_receipt',
                resource: 'consignment_issue_receipt',
                icon: 'fa fa-user',
                url: 'consignment_issue_receipt',
                auto_crud: true,
                breadcrumb: 'Consignment Issue Receipt'
            },
            {
                name: 'menu.consignment_issue_return',
                resource: 'consignment_issue_return',
                icon: 'fa fa-user',
                url: 'consignment_issue_return',
                auto_crud: true,
                breadcrumb: 'Consignment Issue Return'
            },
            {
                name: 'menu.consignment_return_receipt',
                resource: 'consignment_return_receipt',
                icon: 'fa fa-user',
                url: 'consignment_return_receipt',
                auto_crud: true,
                breadcrumb: 'Consignment Return Rececipt'
            },
            {
                name: 'menu.consignment_issue_return',
                resource: 'consignment_challan_return',
                icon: 'fa fa-user',
                url: 'consignment_challan_return',
                auto_crud: true,
                breadcrumb: 'Consignment Issue Return'
            },
            {
                name: 'menu.scm_direct_receive',
                resource: 'scm_grnMaster',
                icon: 'fa fa-user',
                url: 'scm_grnMaster',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },
            {
                name: 'menu.sa_grn_master',
                resource: 'sa_grn_master',
                icon: 'fa fa-user',
                url: 'sa_grn_master',
                auto_crud: true,
                breadcrumb: 'Service Agreement GRN'
            },
            {
                name: 'menu.citizen_item_price_mapping',
                resource: 'citizen_item_price_mapping',
                icon: 'fa fa-user',
                url: 'citizen_item_price_mapping',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },
            {
                name: 'Process Order',
                resource: 'scm_order_tab',
                icon: 'fa fa-user',
                url: 'scm_order_tab',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },
            {
                name: 'Process Order',
                resource: 'scm_order',
                icon: 'fa fa-user',
                url: 'scm_order',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },
            {
                name: 'Process Order',
                resource: 'scm_order_approved',
                icon: 'fa fa-user',
                url: 'scm_order_approved',
                auto_crud: true,
                breadcrumb: 'Direct Receive'
            },
            {
                name: 'Rack Master',
                resource: 'rack_master',
                icon: 'fa fa-user',
                url: 'rack_master',
                auto_crud: true,
                breadcrumb: 'Rack Master'
            }
        ]
    },
    {
        name: 'menu.opticalStore',
        icon: 'fa fa-building-o',
        children: [
            {
                name: 'menu.itemOptical',
                resource: 'itemOptical',
                icon: 'fa fa-user',
                url: 'itemOptical',
                auto_crud: true,
                breadcrumb: 'Frame ADD'
            },
            {
                name: 'menu.itemOptical',
                resource: 'optical_color_master',
                icon: 'fa fa-user',
                url: 'optical_color_master',
                auto_crud: true,
                breadcrumb: 'Frame ADD'
            },
            {
                name: 'menu.itemOptical',
                resource: 'optical_quality_master',
                icon: 'fa fa-user',
                url: 'optical_quality_master',
                auto_crud: true,
                breadcrumb: 'Frame ADD'
            },
            {
                name: 'menu.itemOptical',
                resource: 'optical_shape_master',
                icon: 'fa fa-user',
                url: 'optical_shape_master',
                auto_crud: true,
                breadcrumb: 'Frame ADD'
            },
            {
                name: 'menu.itemOptical',
                resource: 'optical_type_master',
                icon: 'fa fa-user',
                url: 'optical_type_master',
                auto_crud: true,
                breadcrumb: 'Frame ADD'
            },
            {
                name: 'menu.itemOptical',
                resource: 'optical_size_master',
                icon: 'fa fa-user',
                url: 'optical_size_master',
                auto_crud: true,
                breadcrumb: 'Frame ADD'
            },
            {
                name: 'menu.itemOptical',
                resource: 'optical_material_master',
                icon: 'fa fa-user',
                url: 'optical_material_master',
                auto_crud: true,
                breadcrumb: 'Frame ADD'
            },
            {
                name: 'menu.itemOptical',
                resource: 'optical_brand_master',
                icon: 'fa fa-user',
                url: 'optical_brand_master',
                auto_crud: true,
                breadcrumb: 'Frame ADD'
            },
            {
                name: 'menu.itemOptical',
                resource: 'optical_coating_master',
                icon: 'fa fa-user',
                url: 'optical_coating_master',
                auto_crud: true,
                breadcrumb: 'Add Coating'
            },
            {
                name: 'menu.itemOptical',
                resource: 'optical_power_master',
                icon: 'fa fa-user',
                url: 'optical_power_master',
                auto_crud: true,
                breadcrumb: 'Frame ADD'
            },
            {
                name: 'menu.supplierWise_workOrder',
                resource: 'supplierWise_workOrder',
                icon: 'fa fa-user',
                url: 'supplierWise_workOrder',
                auto_crud: true,
                breadcrumb: 'Frame ADD'
            }
        ]
    }

]
